module.exports = __webpack_public_path__ + "ab134068fd52b3cf95be9e3e30512362.png";